import React, {useRef, useEffect} from "react";
import classes from "./LargePhoto.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const LargePhoto = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const imgRef = useRef(null)

  useEffect(()=>{
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: imgRef.current,
        start: "top 50%",
      },
    });

    timeline.to(imgRef.current, {opacity:1, duration:1})
  })

  return (
    <div className={classes.LargePhoto}>
      <img ref={imgRef} src={props.src} alt={props.alt} />
    </div>
  );
};

export default LargePhoto;
